// DS6.7
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Tag.scss';
/**
 * A tag for use with our `<InputField />` and related components.
 *
 * This will render a `<span>` or `<PlainButtonOrLink />` depending on if `onClick` is passed.
 */ const Tag = (_param)=>{
    var { children, size, postfix, className, onClick, href, isSelected, disabled, isTruncated } = _param, rest = _object_without_properties(_param, [
        "children",
        "size",
        "postfix",
        "className",
        "onClick",
        "href",
        "isSelected",
        "disabled",
        "isTruncated"
    ]);
    const ElementTag = !onClick && !href ? 'span' : PlainButtonOrLink;
    return /*#__PURE__*/ React.createElement(ElementTag, _object_spread({
        className: c(s['root'], disabled && s['disabled'], s[size], isSelected && s['selected'], isTruncated && s['truncated'], className),
        href: href,
        onClick: onClick
    }, rest), isTruncated ? /*#__PURE__*/ React.createElement("span", {
        className: s['truncated-contents']
    }, children) : children, postfix && /*#__PURE__*/ React.createElement("span", {
        className: s['postfix']
    }, postfix));
};
Tag.displayName = 'Tag';
export default Tag;

//# sourceMappingURL=Tag.js.map